import { render, staticRenderFns } from "./top.vue?vue&type=template&id=97bf34ca&scoped=true&"
var script = {}
import style0 from "./top.vue?vue&type=style&index=0&id=97bf34ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf34ca",
  null
  
)

export default component.exports